import { UtilityService } from '../../../infrastructure/services/utils';
import { appConstants } from '../../configurations/constants';
import envConfig from '../../configurations/envConfig';
import { store } from '../../store';
import { AnalyticsModel } from './AnalyticsModel';
import { AnalyticsConstants } from './constants';
import { AnalyticsActions } from './IAnalyticsTasks';
import { IResultClick } from './IResultClick';

/**
 * create model for analytics api payload
 * @param   {object} data api payload data
 * @param   {sting} idToken authentication token
 */
export class ResultClickModel extends AnalyticsModel {
  constructor(data: IResultClick) {
    const paxContextGuid = UtilityService.generateGuid();
    super(data, paxContextGuid);

    const appState = store.getState();
    const isSemantic = data.Query && UtilityService.getWordCount(data.Query) >= 4 ? "semanticsearch" : "keywordsearch";
    const toggleSearchMode = data.PageURL?.toLowerCase().includes('browse')
      ? appState.browseSearch.searchModeBrowse
      : appState.search.searchMode;
    const toggleBasedSearchMode = toggleSearchMode === 'Semantic' ? 'semanticsearch' : 'keywordsearch';
    const isEypkcVertical = window.location.href?.toLowerCase().includes('v=eypkc')
      || data.PageURL?.toLowerCase().includes('v=eypkc');
    let siteSearchMode = isEypkcVertical ? 'keywordsearch' : toggleBasedSearchMode;
    if ((envConfig.forceKeywordSearchNews && data.Vertical === appConstants.verticals.News) || (envConfig.forceKeywordSearchPeople && data.Vertical === appConstants.verticals.People)) {
      siteSearchMode = 'keywordsearch';
    }
    const site = window.location.origin
      ? `${window.location.origin}#${siteSearchMode}`
      : null;
    if (this.analyticsData.eventData) {
      this.analyticsData.document = [
        {
          ...this.analyticsData.eventData,          
          Query: data.Query ? data.Query : '',
          Issues: [AnalyticsConstants.NoIssues],
          SearchURL: window.location.href ? window.location.href : null,
          Page: data.Page ? data.Page : '1',
          Document: data.Document ? data.Document : null,
          Position: data.Position ? data.Position : 0,
          PageURL: (window.location.origin + '/#' + data.PageURL) ? window.location.origin + '/#' + data.PageURL : null,
          ActionsSequence: data.ActionsSequence ? data.ActionsSequence : {},
          Action: AnalyticsActions.resultItem,
          Title: data.Title ? UtilityService.removeHtmlTags(data.Title) : null,
          Vertical: data.Vertical ? data.Vertical : '',
          WasSuggested: data.WasSuggested
            ? data.WasSuggested
            : AnalyticsConstants.falseString,
          WasRecentSearch: data.WasRecentSearch
            ? data.WasRecentSearch
            : AnalyticsConstants.falseString,
            ...(data.ItemClickType !== '' ? { ItemClickType: data.ItemClickType } :{ItemClickType:null} ),
            Site: site
        }
      ];
      delete this.analyticsData.eventData;
    }
  }
}
